module.exports = "//static.hsappstatic.net/marketplace-ui-details/static-1.9966/img/hubspot-sprocket.svg"